import { createSlice } from '@reduxjs/toolkit';

const user = createSlice({
    name: 'user',
    initialState: {
        firstname: '',
        lastname: '',
        patronymic: '',
        fullname: '',
        roles: [],
        username: '',
        email: '',
        status_id: '',
        contact_phone: '',
        school_name: '',
        parents: [],
        school_bin: '',
        school_city: '',
        school_id: '',
        activeRole: '',
        subscriptions: [],
        user_id: '',
        kund_user_id: 0,
        last_login: '',
    },
    reducers: {
        setName(state, action) {
            state.firstname = action.payload.firstname;
            state.lastname = action.payload.lastname;
        },
        setActiveRole(state, action) {
            state.activeRole = action.payload;
        },
        setUser(state, action) {
            Object.assign(state, action.payload);
        },
        clearUser(state) {
            Object.assign(state, {
                firstname: '',
                lastname: '',
                roles: [],
                username: '',
                patronymic: '',
                fullname: '',
                email: '',
                status_id: '',
                activeRole: '',
                contact_phone: '',
                school_name: '',
                parents: [],
                school_bin: '',
                school_city: '',
                school_id: '',
                subscriptions: [],
                school_city_name: '',
                user_id: '',
                kund_user_id: '',
                last_login: '',
            });
        }
    }
});

export default user.reducer;

export const { setName, setActiveRole, setUser, clearUser } = user.actions;
